<body>
  <div id="layout">
    <header>
      <div class="container" id="menu">
        <div class="row">
          <div class="col-xs-4 col-sm-3 col-lg-4">
            <a href="https://www.rastreator.com" class="logo" aria-label="Enlace a página principal" role="img"></a>
          </div>
          <div class="col-xs-8 col-sm-9 col-lg-8 menu-wrapper">
            <span class="icon icon-menu hidden-md hidden-lg menu-trigger"></span>
            <div id="mobile-menu-options" class="hidden-md hidden-lg depth-0">
              <span class="icon icon-chevron-left back-trigger hidden"></span>
              <span class="product-title hidden"></span>
              <span class="icon icon-cancel close-trigger"></span>
            </div>
            <nav class="rastreator-menu home-page">
              <ul id="main-menu" class="main-menu">
                <li>
                  <a href="https://www.rastreator.com/seguros.aspx">
                    Seguros
                    <span data-product-title="Seguros" class="icon icon-chevron-down submenu-trigger"></span>
                  </a>
                  <ul class="sub-menu depth-0">
                    <span>
                      <li>
                        <span>Lo más comparado</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-coche.aspx"> <span class="icon icon-product-car-ins"></span> Seguros de Coche </a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-moto.aspx"> <span class="icon icon-product-bike-ins"></span> Seguros de Moto </a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-hogar.aspx"> <span class="icon icon-product-home-ins"></span> Seguro de Hogar </a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-salud.aspx"> <span class="icon icon-product-health-ins"></span> Seguros de Salud </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span>Más seguros</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-viaje.aspx">Seguros de Viaje</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-vida.aspx">Seguros de Vida</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-mascotas.aspx">Seguros de Mascotas</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguro-decesos.aspx">Seguro de Decesos</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-furgonetas.aspx">Seguros de Furgonetas</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguro-accidentes.aspx">Seguro de Accidentes</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguro-por-dias.aspx">Seguros por Días</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguro-impago-alquiler.aspx">Seguro de Impago de Alquiler</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguros-empresas.aspx">Seguros para Empresas</a>
                          </li>
                        </ul>
                      </li>
                    </span>
                  </ul>
                </li>
                <li>
                  <a href="https://www.rastreator.com/telefonia.aspx">
                    Internet y Telefonía
                    <span data-product-title="Internet y Telefonía" class="icon icon-chevron-down submenu-trigger"></span>
                  </a>
                  <ul class="sub-menu depth-0">
                    <span>
                      <li>
                        <span>Lo más comparado</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/tarifas-internet-fijo-movil.aspx"> <span class="icon icon-product-telephony"></span> Internet + Fijo + Móvil </a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/tarifas-movil.aspx"> <span class="icon icon-product-mobile"></span> Tarifas Móviles </a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/tarifas-internet-fijo-movil-tv.aspx"> <span class="icon icon-product-tv"></span> Internet + Fijo + Móvil + TV </a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/tarifas-internet-sin-fijo.aspx"> <span class="icon icon-product-internet"></span> Internet sin fijo </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span>Más opciones</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/comprar-moviles.aspx">Comprar Móvil</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/vender-movil.aspx">Vender Móvil</a>
                          </li>
                        </ul>
                      </li>
                    </span>
                  </ul>
                </li>
                <li>
                  <a href="https://www.rastreator.com/finanzas.aspx">
                    Hipotecas y Finanzas
                    <span data-product-title="Hipotecas y Finanzas" class="icon icon-chevron-down submenu-trigger"></span>
                  </a>
                  <ul class="sub-menu depth-0">
                    <span>
                      <li>
                        <span>Lo más comparado</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/hipotecas.aspx"> <span class="icon icon-product-mortgages"></span> Hipotecas </a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/prestamos-personales.aspx"> <span class="icon icon-product-loans"></span> Préstamos Personales </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span>Más opciones</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/tarjeta-credito.aspx">Tarjetas</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/cuentas-bancarias.aspx">Cuentas Bancarias</a>
                          </li>
                        </ul>
                      </li>
                    </span>
                  </ul>
                </li>
                <li>
                  <a href="https://www.rastreator.com/viajes.aspx">
                    Viajes
                    <span data-product-title="Viajes" class="icon icon-chevron-down submenu-trigger"></span>
                  </a>
                  <ul class="sub-menu depth-0">
                    <span>
                      <li>
                        <span>Lo más comparado</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/alquiler-de-coches.aspx"> <span class="icon icon-product-rentalcars"></span> Alquiler de coches </a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/vuelos.aspx"> <span class="icon icon-product-flights"></span> Vuelos </a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/hoteles.aspx"> <span class="icon icon-product-hotels"></span> Hoteles </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span>Más opciones</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/apartamentos-vacaciones.aspx">Apartamentos Vacacionales</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/billetes-ferry.aspx">Billetes de Ferry</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/billetes-de-tren.aspx">Billetes de tren</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/billetes-de-autobus.aspx">Billetes de Autobús</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/traslado-aeropuerto.aspx">Traslados Aeropuerto</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/cruceros.aspx">Cruceros</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-viaje.aspx">Seguros de Viaje</a>
                          </li>
                        </ul>
                      </li>
                    </span>
                  </ul>
                </li>
                <li>
                  <a href="https://coches.rastreator.com/">
                    Coches
                    <span data-product-title="Coches" class="icon icon-chevron-down submenu-trigger"></span>
                  </a>
                  <ul class="sub-menu depth-0">
                    <span>
                      <li>
                        <span>Lo más comparado</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://coches.rastreator.com"> <span class="icon icon-product-carbs"></span> Comprar Coche </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span>Comparador de coches</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://coches.rastreator.com/nuevo">Nuevos</a>
                          </li>
                          <li>
                            <a href="https://coches.rastreator.com/segunda-mano">Segunda Mano</a>
                          </li>
                          <li>
                            <a href="https://coches.rastreator.com/stock-km0">Stock / km 0</a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span>Otros servicios</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/alquiler-de-coches.aspx">Alquiler de Coches</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/seguros-de-coche.aspx">Seguros de Coche</a>
                          </li>
                          <li>
                            <a href="https://coches.rastreator.com/itv-para-coche">ITV</a>
                          </li>
                        </ul>
                      </li>
                    </span>
                  </ul>
                </li>
                <li>
                  <a href="https://www.rastreator.com/energia.aspx">
                    Energía
                    <span data-product-title="Energía" class="icon icon-chevron-down submenu-trigger"></span>
                  </a>
                  <ul class="sub-menu depth-0">
                    <span>
                      <li>
                        <span>Destacado</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/tarifas-energia.aspx"> <span class="icon icon-product-energy"></span> Tarifas de Luz y Gas </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span>Otros</span>
                        <ul class="sub-menu depth-1">
                          <li>
                            <a href="https://www.rastreator.com/tarifas-electricidad-para-empresas.aspx">Tarifas de Luz y Gas para Empresas</a>
                          </li>
                          <li>
                            <a href="https://www.rastreator.com/certificado-energetico.aspx">Certificados Energéticos</a>
                          </li>
                        </ul>
                      </li>
                    </span>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
    <main class="main-content">
      <section class="main-claim">
        <div class="container">
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <h1>Cuestionarios Salud</h1>
            </div>
          </div>
        </div>
      </section>
      <section class="insurers">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <h2>Aseguradoras</h2>
              <div class="row">
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_Adeslas.pdf"
                    target="_blank"
                    download="Cuestionario_Adeslas.pdf"
                    title="Descarga el cuestionario de Adeslas">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}adeslas.png"
                      srcset="{{baseImageUrl}}adeslas@2x.png 2x, {{baseImageUrl}}adeslas@3x.png 3x"
                      alt="logo Adeslas"
                      title="logo Adeslas"
                      class="img img-hidden" />
                    <span class="name">Adeslas</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a class="insurer-logo loading clickable" href="{{ baseDocUrl }}Cuestionario_Aegon.xlsx" target="_blank" download="Cuestionario_Aegon.xlsx" title="Descarga el cuestionario de Aegon">
                    <span class="icon icon-download downloadable"></span>
                    <img src="{{ baseImageUrl }}aegon.png" srcset="{{baseImageUrl}}aegon@2x.png 2x, {{baseImageUrl}}aegon@3x.png 3x" alt="logo Aegon" title="logo Aegon" class="img img-hidden" />
                    <span class="name">Aegon</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a class="insurer-logo loading clickable" href="{{ baseDocUrl }}Cuestionario_Asisa.pdf" target="_blank" download="Cuestionario_Asisa.pdf" title="Descarga el cuestionario de Asisa">
                    <span class="icon icon-download downloadable"></span>
                    <img src="{{ baseImageUrl }}asisa.png" srcset="{{baseImageUrl}}asisa@2x.png 2x, {{baseImageUrl}}asisa@3x.png 3x" alt="logo Asisa" title="logo Asisa" class="img img-hidden" />
                    <span class="name">Asisa</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <div class="insurer-logo loading">
                    <img src="{{ baseImageUrl }}axa.png" srcset="{{baseImageUrl}}axa@2x.png 2x, {{baseImageUrl}}axa@3x.png 3x" alt="logo AXA" title="logo AXA" class="img img-hidden" />
                    <span class="name">AXA</span>
                  </div>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <div class="insurer-logo loading">
                    <img src="{{ baseImageUrl }}cigna.png" srcset="{{baseImageUrl}}cigna@2x.png 2x, {{baseImageUrl}}cigna@3x.png 3x" alt="logo Cigna" title="logo Cigna" class="img img-hidden" />
                    <span class="name">Cigna</span>
                  </div>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_Clínicum.pdf"
                    target="_blank"
                    download="Cuestionario_Clínicum.pdf"
                    title="Descarga el cuestionario de Clinicum Salut">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}clinicum.png"
                      srcset="{{baseImageUrl}}clinicum@2x.png 2x, {{baseImageUrl}}clinicum@3x.png 3x"
                      alt="logo Clinicum Salut"
                      title="logo Clinicum Salut"
                      class="img img-hidden" />
                    <span class="name">Clinicum Salut</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_DivinaSeguros.pdf"
                    target="_blank"
                    download="Cuestionario_DivinaSeguros.pdf"
                    title="Descarga el cuestionario de Divina Pastora">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}divina-seguros.png"
                      srcset="{{baseImageUrl}}divina-seguros@2x.png 2x, {{baseImageUrl}}divina-seguros@3x.png 3x"
                      alt="logo Divina Pastora"
                      title="logo Divina Pastora"
                      class="img img-hidden" />
                    <span class="name">Divina Pastora</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a class="insurer-logo loading clickable" href="{{ baseDocUrl }}Cuestionario_DKV.pdf" target="_blank" download="Cuestionario_DKV.pdf" title="Descarga el cuestionario de DKV">
                    <span class="icon icon-download downloadable"></span>
                    <img src="{{ baseImageUrl }}dkv.png" srcset="{{baseImageUrl}}dkv@2x.png 2x, {{baseImageUrl}}dkv@3x.png 3x" alt="logo DKV" title="logo DKV" class="img img-hidden" />
                    <span class="name">DKV</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_Elmacare_(Caser).pdf"
                    target="_blank"
                    download="Cuestionario_Elmacare_(Caser).pdf"
                    title="Descarga el cuestionario de Elmacare">
                    <span class="icon icon-download downloadable"></span>
                    <img src="{{ baseImageUrl }}elma.png" srcset="{{baseImageUrl}}elma@2x.png 2x, {{baseImageUrl}}elma@3x.png 3x" alt="logo Elmacare" title="logo Elmacare" class="img img-hidden" />
                    <span class="name">Elmacare</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <div class="insurer-logo loading">
                    <img src="{{ baseImageUrl }}fiatc.png" srcset="{{baseImageUrl}}fiatc@2x.png 2x, {{baseImageUrl}}fiatc@3x.png 3x" alt="logo FIATC" title="logo FIATC" class="img img-hidden" />
                    <span class="name">FIATC</span>
                  </div>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <div class="insurer-logo loading">
                    <img
                      src="{{ baseImageUrl }}generali.png"
                      srcset="{{baseImageUrl}}generali@2x.png 2x, {{baseImageUrl}}generali@3x.png 3x"
                      alt="logo Generali"
                      title="logo Generali"
                      class="img img-hidden" />
                    <span class="name">Generali</span>
                  </div>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionarios_MAPFRE.pdf"
                    target="_blank"
                    download="Cuestionarios_MAPFRE.pdf"
                    title="Descarga el cuestionario de Mapfre">
                    <span class="icon icon-download downloadable"></span>
                    <img src="{{ baseImageUrl }}mapfre.png" srcset="{{baseImageUrl}}mapfre@2x.png 2x, {{baseImageUrl}}mapfre@3x.png 3x" alt="logo Mapfre" title="logo Mapfre" class="img img-hidden" />
                    <span class="name">Mapfre</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_Acunsa.pdf"
                    target="_blank"
                    download="Cuestionario_Acunsa.pdf"
                    title="Descarga el cuestionario de ACUNSA (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}acunsa.png"
                      srcset="{{baseImageUrl}}acunsa@2x.png 2x, {{baseImageUrl}}acunsa@3x.png 3x"
                      alt="logo ACUNSA (PyS)"
                      title="logo ACUNSA (PyS)"
                      class="img img-hidden" />
                    <span class="name">ACUNSA (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_Adeslas.pdf"
                    target="_blank"
                    download="Cuestionario_Adeslas.pdf"
                    title="Descarga el cuestionario de Adeslas (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}adeslas-ps.png"
                      srcset="{{baseImageUrl}}adeslas-ps@2x.png 2x, {{baseImageUrl}}adeslas-ps@3x.png 3x"
                      alt="logo Adeslas (PyS)"
                      title="logo Adeslas (PyS)"
                      class="img img-hidden" />
                    <span class="name">Adeslas (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_ALBADIS_(Asefa).pdf"
                    target="_blank"
                    download="Cuestionario_ALBADIS_(Asefa).pdf"
                    title="Descarga el cuestionario de Albadis (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}albadis.png"
                      srcset="{{baseImageUrl}}albadis@2x.png 2x, {{baseImageUrl}}albadis@3x.png 3x"
                      alt="logo Albadis (PyS)"
                      title="logo Albadis (PyS)"
                      class="img img-hidden" />
                    <span class="name">Albadis (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_Asefa.pdf"
                    target="_blank"
                    download="Cuestionario_Asefa.pdf"
                    title="Descarga el cuestionario de Asefa (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}asefa.png"
                      srcset="{{baseImageUrl}}asefa@2x.png 2x, {{baseImageUrl}}asefa@3x.png 3x"
                      alt="logo Asefa (PyS)"
                      title="logo Asefa (PyS)"
                      class="img img-hidden" />
                    <span class="name">Asefa (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Solicitud_MURIMAR.pdf"
                    target="_blank"
                    download="Solicitud_MURIMAR.pdf"
                    title="Descarga el cuestionario de Murimar (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}murimar.png"
                      srcset="{{baseImageUrl}}murimar@2x.png 2x, {{baseImageUrl}}murimar@3x.png 3x"
                      alt="logo Murimar (PyS)"
                      title="logo Murimar (PyS)"
                      class="img img-hidden" />
                    <span class="name">Murimar (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Solicitud_Plus_ultra.pdf"
                    target="_blank"
                    download="Solicitud_Plus_ultra.pdf"
                    title="Descarga el cuestionario de Plus Ultra (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}plus-ultra.png"
                      srcset="{{baseImageUrl}}plus-ultra@2x.png 2x, {{baseImageUrl}}plus-ultra@3x.png 3x"
                      alt="logo Plus Ultra (PyS)"
                      title="logo Plus Ultra (PyS)"
                      class="img img-hidden" />
                    <span class="name">Plus Ultra (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <div class="insurer-logo loading">
                    <img
                      src="{{ baseImageUrl }}previsora.png"
                      srcset="{{baseImageUrl}}previsora@2x.png 2x, {{baseImageUrl}}previsora@3x.png 3x"
                      alt="logo Previsora general (PyS)"
                      title="logo Previsora general (PyS)"
                      class="img img-hidden" />
                    <span class="name">Previsora general (PyS)</span>
                  </div>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Solicitud_QUIEROSALUD.pdf"
                    target="_blank"
                    download="Solicitud_QUIEROSALUD.pdf"
                    title="Descarga el cuestionario de Quiero Salud (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}quiero-salud.png"
                      srcset="{{baseImageUrl}}quiero-salud@2x.png 2x, {{baseImageUrl}}quiero-salud@3x.png 3x"
                      alt="logo Quiero Salud (PyS)"
                      title="logo Quiero Salud (PyS)"
                      class="img img-hidden" />
                    <span class="name">Quiero Salud (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a class="insurer-logo loading clickable" href="{{ baseDocUrl }}Solicitud_SALUS.pdf" target="_blank" download="Solicitud_SALUS.pdf" title="Descarga el cuestionario de Salus (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}salus.png"
                      srcset="{{baseImageUrl}}salus@2x.png 2x, {{baseImageUrl}}salus@3x.png 3x"
                      alt="logo Salus (PyS)"
                      title="logo Salus (PyS)"
                      class="img img-hidden" />
                    <span class="name">Salus (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_Sanitas.pdf"
                    target="_blank"
                    download="Cuestionario_Sanitas.pdf"
                    title="Descarga el cuestionario de Sanitas (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}sanitas-ps.png"
                      srcset="{{baseImageUrl}}sanitas-ps@2x.png 2x, {{baseImageUrl}}sanitas-ps@3x.png 3x"
                      alt="logo Sanitas (PyS)"
                      title="logo Sanitas (PyS)"
                      class="img img-hidden" />
                    <span class="name">Sanitas (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <div class="insurer-logo loading">
                    <img
                      src="{{ baseImageUrl }}servibucal.png"
                      srcset="{{baseImageUrl}}servibucal@2x.png 2x, {{baseImageUrl}}servibucal@3x.png 3x"
                      alt="logo Servibucal (PyS)"
                      title="logo Servibucal (PyS)"
                      class="img img-hidden" />
                    <span class="name">Servibucal (PyS)</span>
                  </div>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_Asisa.pdf"
                    target="_blank"
                    download="Cuestionario_Asisa.pdf"
                    title="Descarga el cuestionario de Start (PyS)">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}start.png"
                      srcset="{{baseImageUrl}}start@2x.png 2x, {{baseImageUrl}}start@3x.png 3x"
                      alt="logo Start (PyS)"
                      title="logo Start (PyS)"
                      class="img img-hidden" />
                    <span class="name">Start (PyS)</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <a
                    class="insurer-logo loading clickable"
                    href="{{ baseDocUrl }}Cuestionario_Sanitas.pdf"
                    target="_blank"
                    download="Cuestionario_Sanitas.pdf"
                    title="Descarga el cuestionario de Sanitas">
                    <span class="icon icon-download downloadable"></span>
                    <img
                      src="{{ baseImageUrl }}sanitas.png"
                      srcset="{{baseImageUrl}}sanitas@2x.png 2x, {{baseImageUrl}}sanitas@3x.png 3x"
                      alt="logo Sanitas"
                      title="logo Sanitas"
                      class="img img-hidden" />
                    <span class="name">Sanitas</span>
                  </a>
                </article>
                <article class="col-xs-4 col-sm-3 col-lg-2">
                  <div class="insurer-logo loading">
                    <img src="{{ baseImageUrl }}vivaz.png" srcset="{{baseImageUrl}}vivaz@2x.png 2x, {{baseImageUrl}}vivaz@3x.png 3x" alt="logo Vivaz" title="logo Vivaz" class="img img-hidden" />
                    <span class="name">Vivaz</span>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer>
      <div class="divider hidden-sm hidden-md hidden-lg"></div>
      <section class="footer-classic">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-8 col-md-5 legal">
              <ul class="clearfix">
                <li>
                  <a href="https://www.rastreator.com/aviso-legal.aspx" target="blank" rel="nofollow" class="blue-02-bg" title="Rastreator.com - Aviso Legal">Aviso Legal</a>
                </li>
                <li>
                  <a href="https://www.rastreator.com/politica-de-cookies.aspx" target="blank" rel="nofollow" class="blue-02-bg" title="Rastreator.com - Política de Cookie">Política de Cookie</a>
                </li>
                <li>
                  <a href="https://www.rastreator.com/politica-de-privacidad.aspx" target="blank" rel="nofollow" class="blue-02-bg" title="Rastreator.com - Política de Privacidad"
                    >Política de Privacidad</a
                  >
                </li>
              </ul>
              <div class="divider hidden-sm hidden-md hidden-lg"></div>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-7 copyright-wrapper">
              <p class="copyright">
                &copy; Copyright Rastreator.com 2024.
                <br />Todos los Derechos Reservados
              </p>
            </div>
          </div>
        </div>
      </section>
    </footer>
  </div>
  <script src="/assets/js/cuestionarios-salud.js" type="text/javascript"></script>
</body>
